import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('meio-ambientes',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('meio-ambientes',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('meio-ambientes/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('meio-ambientes/'+item.id_meio_ambiente,item,{
            headers:{
                'Authorization':token
            }
        })
    }
}